export default __webpack_public_path__ + "swim-safety-profiles-dark.svg";